import { Mui } from "@osu/react-ui";
import { mergeSxStyles } from "../../util/functions";

function DashboardAlert({ message, role, sx, ...rest }) {
  let alertProps = {};
  if (message) {
    alertProps.severity = "info";
    alertProps.component = Mui.Alert;
  }
  if(role !== "none")  {
    alertProps["aria-live"] = "polite"
    alertProps["aria-atomic"] = "true"
  }
 
  return (
    <Mui.Box
      sx={mergeSxStyles(sx, { whiteSpace: 'pre-wrap' })}
      role={role || "status"}
      {...alertProps}
      {...rest}
    >
      {message}
    </Mui.Box>
  );
}

export default DashboardAlert;
